import React from 'react';
import { manufacturerBrands } from '../../data/modalities';
export function ManufacturerStrip() {
  return <section className="w-full border-y border-slate-200 bg-slate-50/90" data-id="element-210" data-mp="1ehc30zzhkuqb">
      <div className="mx-auto max-w-7xl px-5 py-7 sm:px-8 sm:py-7" data-id="element-211" data-mp="1tdjqqaa3seac">
        <p className="text-center text-[11px] font-semibold uppercase tracking-[0.16em] text-charcoal/55" data-id="element-212" data-mp="1tbqi4pfxjjzp">
          Curated technologies from trusted modality brands
        </p>
        <div className="mt-4 flex flex-wrap justify-center gap-2.5" data-id="element-213" data-mp="22cx258hsfcxp">
          {manufacturerBrands.map(brand => <span key={brand} className="rounded-full border border-slate-200 bg-white px-3.5 py-2 text-xs font-semibold tracking-wide text-navy shadow-sm" data-id="element-214" data-mp="1xdbzoo3esmg8">
              {brand}
            </span>)}
        </div>
      </div>
    </section>;
}